/* SP-SDE v09 — draft ONLY. One live title/review node each; native
   product options stay authoritative. Loaded only for four complete models. */
(() => {
  'use strict';
  if (window.__spzFamilyMobilePreviewV09) return;
  window.__spzFamilyMobilePreviewV09 = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  const initialized = new WeakSet();
  const selector = 'product-component.spz-autofiller-mobile-compact';

  function setupFamily(root) {
    if (!root || initialized.has(root)) return;
    const summary = root.querySelector('[data-spz-mobile-summary]');
    const info = root.querySelector('[id^="ProductInfo-"]');
    if (!summary || !info) return;
    initialized.add(root);

    const sources = [
      info.querySelector('.spz-preview-eyebrow-source'),
      info.querySelector('.product__title'),
      info.querySelector('.spz-preview-review-source'),
    ].filter(Boolean);
    const positions = sources.map((node) => {
      const placeholder = document.createComment('SP-SDE original product-info position');
      node.parentNode.insertBefore(placeholder, node);
      return { node, placeholder };
    });

    function arrangeSummary() {
      if (mobile.matches) {
        for (const { node } of positions) summary.appendChild(node);
        summary.hidden = positions.length === 0;
      } else {
        for (const { node, placeholder } of positions) {
          if (placeholder.parentNode) placeholder.parentNode.insertBefore(node, placeholder.nextSibling);
        }
        summary.hidden = true;
      }
    }
    arrangeSummary();

    /* v16: Existing product title + eyebrow move together on mobile; the
       Liquid-sourced review rating lives in summary itself. No DOM search or
       reparenting of asynchronous Judge.me badges is required. */
    const onMobileChange = () => arrangeSummary();
    if (typeof mobile.addEventListener === 'function') {
      mobile.addEventListener('change', onMobileChange);
    } else if (typeof mobile.addListener === 'function') {
      mobile.addListener(onMobileChange);
    }

    // Fail-open: when the custom select is unavailable, leave the existing
    // Shopify radio choices visible and functional.
    const dropdown = root.querySelector('[data-spz-mobile-depth-select]');
    const picker = root.querySelector('variant-selects.spz-depth-has-mobile-dropdown');
    if (dropdown && picker && picker.querySelector('fieldset input[type="radio"]')) {
      root.classList.add('spz-mobile-enhanced');
    }
  }

  document.addEventListener('change', (event) => {
    const dropdown = event.target;
    if (!(dropdown instanceof HTMLSelectElement) ||
        !dropdown.matches('[data-spz-mobile-depth-select]')) return;
    const root = dropdown.closest(selector);
    if (!root || !root.classList.contains('spz-mobile-enhanced')) return;

    const picker = root.querySelector('variant-selects.spz-depth-has-mobile-dropdown');
    const options = picker
      ? Array.from(picker.querySelectorAll('fieldset input[type="radio"]'))
      : [];
    const chosen = options.find((radio) => radio.value === dropdown.value);
    if (!chosen) return;
    if (!chosen.checked) {
      chosen.checked = true;
      chosen.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function initialize(scope = document) {
    scope.querySelectorAll(selector).forEach(setupFamily);
    if (scope.matches && scope.matches(selector)) setupFamily(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();